var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1487,
    height: 150,
    viewBox: "0 0 1487 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1486 149.439L1217.09 149.401L1146.08 88.3838L1486.08 88.4306L1486 149.439Z",
    fill: "#FA405A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338.502 0L1486 0V94H259L338.502 0Z",
    fill: "#FA405A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderbg);
export default __webpack_public_path__ + "static/media/headerbg.b10b0f557d73c8dbb59191b3e4ae12d8.svg";
export { ForwardRef as ReactComponent };